// extracted by mini-css-extract-plugin
module.exports = {"risknotset":"RiskColorCodes_risknotset__2ApGd","norisk":"RiskColorCodes_norisk__2Y8xj","mediumrisk":"RiskColorCodes_mediumrisk__21xhH","highrisk":"RiskColorCodes_highrisk__S4Kv0"};